import {React,useReducer,useEffect} from 'react'
import { WatchedMovies} from '../Component/Fetcher'
import Singlemovie from '../Component/Singlemovie'
import Loader from '../Page/Loader';



const initaistate ={
  loading :true,
  data :[],
  error:'',
 
}
const reducer =(state,action)=>{
 switch(action.type){
  case 'success':
    return{
      ...state,
      loading:false,
      data:action.payload,
      error : '',
      

    }

    case 'failed':
      return{
        ...state,
        loading:true,
        data:'',
        error :action.errormessage,
        
      }
 }
}



const MostWatched = () => {

  const[mostwatch,dispatch] = useReducer(reducer,initaistate)

  useEffect(()=>{
    WatchedMovies({dispatch})
  },[])




const rerender=()=>{
return mostwatch.data.map(data=>
     <Singlemovie key={data.id} data={data}/>
  )
}


  return (
  <>

  <h1 id='most-watched'> Marvel Most Watched Movie</h1>
  {mostwatch.loading ? <Loader/> : ''}
    <div id='single-wrapper'>

    {mostwatch.loading ? '': rerender()}
    {mostwatch.error ? mostwatch.error:null}



    </div>
    </>
  )
}

export default MostWatched